import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  attemptGoalRequest: ["id"],
  attemptGoalSuccess: ["goal"],
  attemptGoalFailure: null,
});

export const AttemptGoalTypes = Types;
export const AttemptGoalActions = Creators;
export default Creators;

export const INITIAL_STATE = Immutable({
  id: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
});

export const AttemptGoalSelectors = {
  getData: (state: any) => state.attemptGoal.data,
  isFetching: (state: any) => state.attemptGoal.fetching,
  isSuccess: (state: any) => state.attemptGoal.success,
  hasError: (state: any) => state.attemptGoal.error,
};

export const request = (state: any, { id }: any) => {
  const updateData = {
    fetching: true,
    id,
    success: false,
    error: false,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { goal } = action;
    const updateData = {
    fetching: false,
    success: true,
    error: false,
    goal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ATTEMPT_GOAL_REQUEST]: request,
  [Types.ATTEMPT_GOAL_SUCCESS]: success,
  [Types.ATTEMPT_GOAL_FAILURE]: failure,
});
